import {
    Box,
    Stack,
    Typography,
} from '@mui/material'
import Image from 'next/image'
import WhyApply1 from '../../../assets/why-apply/whyapply1.png'
import WhyApply2 from '../../../assets/why-apply/whyapply2.png'
import WhyApply3 from '../../../assets/why-apply/whyapply3.png'
import WhyApply4 from '../../../assets/why-apply/whyapply4.png'
import { useTranslation } from 'react-i18next'

export const SMHomeWhyApply: React.FC = () => {

    const { t } = useTranslation()

    const data = [
        {
            'icon': WhyApply1,
            'title': t('t62'),
            'content': t('t63')
        },
        {
            'icon': WhyApply2,
            'title': t('t64'),
            'content': t('t65')
        },
        {
            'icon': WhyApply3,
            'title': t('t66'),
            'content': t('t67')
        },
        {
            'icon': WhyApply4,
            'title': t('t68'),
            'content': t('t69')
        }
    ]

    // ======================= StepItem
    const stepItem = (index: number) => {
        return (
            <Box
            key={index}
             sx={{
                flex: '1',
                flexDirection: 'column',
                display: 'flex',
                alignItems: 'center',
                paddingLeft: '12px',
                paddingRight: '12px',
            }}>
                <Box sx={{
                    position: 'relative',
                    backgroundColor: '#FFF8E7',
                    marginTop: '35px',
                    width: '100%',
                    height: '100%',
                    borderRadius: '10px',
                    paddingTop: '55px',
                    paddingBottom: '30px',
                    paddingLeft: '18px',
                    paddingRight: '18px',
                }}>
                    <Typography fontWeight={600} fontSize={'20px'} color={'#141F39'} textAlign={'center'}>
                        {data[index]['title']}
                    </Typography>

                    <Typography paddingTop={'15px'} fontWeight={400} fontSize={'16px'} color={'#6B6B6B'} textAlign={'center'}>
                        {data[index]['content']}
                    </Typography>
                </Box>
                <Box sx={{
                    position: 'absolute',
                    height: '70px',
                }}>
                    <Image src={data[index]['icon']} width={70} height={70} alt=''></Image>
                </Box>
            </Box>
        )
    }

    // ======================= VIEWS
    return (
        <Box
            paddingBottom={{ xs: 2, lg: 5 }}
        >
            <Typography variant='h5' width={'100%'} textAlign={'center'} paddingTop={'60px'} paddingBottom={'40px'} fontWeight={700}>
                {t('t61')}
            </Typography>

            <Box sx={{
                width: '100%',
                paddingLeft: '160px',
                paddingRight: '160px'
            }}>
                <Stack
                    direction='row'
                    display={{
                        xs: 'none',
                        lg: 'flex',
                    }}
                    justifyContent='space-between'>
                    {data.map((item, index) => stepItem(index))}
                </Stack>
            </Box>
        </Box>
    )
}

// ======================= EXPORT
export default SMHomeWhyApply
